import { isMacUserAgent, isServerSide } from '../user-agent.mjs';
import { GenericHotKey, MacHotKey, WindowsHotKey } from './keys.mjs';

function hasAltKeySymbol(keys) {
  return keys.includes(GenericHotKey.Alt) || keys.includes(MacHotKey.Alt);
}
function hasControlKeySymbol(keys) {
  if (isMacUserAgent()) {
    return keys.includes(MacHotKey.Control);
  }
  return keys.includes(GenericHotKey.Control);
}
function hasMetaKeySymbol(keys) {
  if (isMacUserAgent()) {
    return keys.includes(GenericHotKey.Control) || keys.includes(MacHotKey.Meta);
  }
  return keys.includes(GenericHotKey.Meta) || keys.includes(WindowsHotKey.Meta);
}
function hasShiftKeySymbol(keys) {
  return keys.includes(GenericHotKey.Shift) || keys.includes(MacHotKey.Shift);
}
function hasEnterKeySymbol(keys) {
  return keys.includes(GenericHotKey.Enter) || keys.includes(MacHotKey.Enter);
}
function hasBackspaceKeySymbol(keys) {
  return keys.includes(GenericHotKey.Backspace) || keys.includes(MacHotKey.Backspace);
}
function hasArrowUpKeySymbol(keys) {
  return keys.includes(GenericHotKey.ArrowUp);
}
function hasArrowDownKeySymbol(keys) {
  return keys.includes(GenericHotKey.ArrowDown);
}
function getAltKeySymbol() {
  if (isServerSide()) {
    return null;
  }
  return isMacUserAgent() ? MacHotKey.Alt : WindowsHotKey.Alt;
}
function getControlKeySymbol(forceMacControl = false) {
  if (isServerSide()) {
    return null;
  }
  if (!isMacUserAgent()) return WindowsHotKey.Control;
  return forceMacControl ? MacHotKey.Control : MacHotKey.Meta;
}
function getMetaKeySymbol() {
  if (isServerSide()) {
    return null;
  }
  return isMacUserAgent() ? MacHotKey.Meta : WindowsHotKey.Meta;
}
function getShiftKeySymbol() {
  if (isServerSide()) {
    return null;
  }
  return isMacUserAgent() ? MacHotKey.Shift : WindowsHotKey.Shift;
}
function getArrowUpKeySymbol() {
  if (isServerSide()) {
    return null;
  }
  return isMacUserAgent() ? MacHotKey.ArrowUp : WindowsHotKey.ArrowUp;
}
function getArrowDownKeySymbol() {
  if (isServerSide()) {
    return null;
  }
  return isMacUserAgent() ? MacHotKey.ArrowDown : WindowsHotKey.ArrowDown;
}
function getEnterKeySymbol() {
  if (isServerSide()) {
    return null;
  }
  return isMacUserAgent() ? MacHotKey.Enter : WindowsHotKey.Enter;
}
function getBackspaceKeySymbol() {
  if (isServerSide()) {
    return null;
  }
  return isMacUserAgent() ? MacHotKey.Backspace : WindowsHotKey.Backspace;
}

export { getAltKeySymbol, getArrowDownKeySymbol, getArrowUpKeySymbol, getBackspaceKeySymbol, getControlKeySymbol, getEnterKeySymbol, getMetaKeySymbol, getShiftKeySymbol, hasAltKeySymbol, hasArrowDownKeySymbol, hasArrowUpKeySymbol, hasBackspaceKeySymbol, hasControlKeySymbol, hasEnterKeySymbol, hasMetaKeySymbol, hasShiftKeySymbol };
